export const product = {
  // Hero
  heroTitle: 'Kancalı Uçlu Çelik Donatı Telleri',
  heroSubtitle: 'Üstün performans ve dayanıklılık için tasarlanmış premium beton güçlendirme çözümü',

  // Overview
  overviewTitle: 'Ürün Genel Bakış',
  overviewDesc: 'DYNAMIX Kancalı Uçlu Çelik Donatı Telleri, premium soğuk çekilmiş çelik telden üretilen yüksek performanslı beton güçlendirme çözümleridir. Tellerimiz, beton matrisinde olağanüstü ankraj sağlayan optimize edilmiş kancalı uç geometrisine sahiptir ve üstün yük transferi ve çatlak kontrolü sağlar.',

  downloadDatasheet: 'Teknik Veri Sayfasını İndir',
  requestQuote: 'Teklif İste',

  // Technical Specs
  specsTitle: 'Teknik Özellikler',
  specsSubtitle: 'En zorlu inşaat gereksinimlerini karşılamak için hassas mühendislik.',

  specMaterial: 'Malzeme',
  specMaterialValue: 'Soğuk çekilmiş çelik tel',

  specTensile: 'Çekme Dayanımı',
  specTensileValue: '1000-1200 MPa',
  specTensileBig: '>1100 MPa',

  specLength: 'Uzunluk',
  specLengthValue: '30-60 mm (özelleştirilebilir)',
  specLengthBig: '30-60 mm',

  specDiameter: 'Çap',
  specDiameterValue: '0.5-1.0 mm',
  specDiameterBig: '0,5-1,0 mm',

  specAspect: 'En-Boy Oranı',
  specAspectValue: '45-80',
  specAspectBig: '45-80',

  specDosage: 'Tipik Dozaj',
  specDosageValue: '20-40 kg/m³',

  specStandard: 'Standart Uyumluluğu',
  specStandardValue: 'ASTM A820, TS EN 14889-1',
  specStandardBig: 'ASTM A820',

  specPackaging: 'Paketleme',
  specPackagingValue: '20 kg torbalar, 1000 kg büyük torbalar',

  // Key Advantages
  advantagesTitle: 'Temel Avantajlar',
  advantagesSubtitle: 'Önde gelen inşaat şirketlerinin neden Dynamix Steel Fiber\'ı seçtiğini keşfedin.',

  adv1Title: 'Gelişmiş Yapısal Performans',
  adv1Desc: 'Betonun çatlak sonrası çekme dayanımını ve yük taşıma kapasitesini önemli ölçüde artırır.',

  adv2Title: 'Üstün Çatlak Kontrolü',
  adv2Desc: 'Üç boyutlu tel ağı, hem plastik hem de sertleşmiş beton çatlaklarını etkili bir şekilde kontrol eder.',

  adv3Title: 'Artan Dayanıklılık',
  adv3Desc: 'Darbe, yorulma ve çevresel faktörlere karşı direnci artırarak beton yapıların hizmet ömrünü uzatır.',

  adv4Title: 'Azaltılmış İnşaat Süresi',
  adv4Desc: 'Zaman alan hasır montajını ortadan kaldırarak proje tamamlanmasını hızlandırır.',

  adv5Title: 'Maliyet Tasarrufu',
  adv5Desc: 'Geleneksel güçlendirme yöntemlerine kıyasla daha düşük işçilik maliyetleri ve azaltılmış malzeme israfı.',

  adv6Title: 'Çok Yönlü Uygulama',
  adv6Desc: 'Endüstriyel zeminlerden tünel kaplamalarına kadar çeşitli beton uygulamaları için uygundur.',
};
